<button mat-icon-button [matMenuTriggerFor]="notificationMenu" #notificationMenuTrigger="matMenuTrigger" class="notification-button" (menuOpened)="onMenuOpened()" matTooltip="Team notifications">
  <mat-icon>notifications</mat-icon>
  <span *ngIf="unreadCount > 0" class="notification-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
</button>

<mat-menu #notificationMenu="matMenu" class="notification-menu" xPosition="before" [overlapTrigger]="false" [hasBackdrop]="true">
  <div class="notification-panel" (click)="$event.stopPropagation()">
    <div class="notification-header">
      <h3>Team Notifications</h3>
      <div class="header-actions">
        <button mat-icon-button [matMenuTriggerFor]="optionsMenu" class="options-button" (click)="onOptionsButtonClick($event)" *ngIf="unreadCount > 0 || notifications.length > 0 || notifications.length > unreadCount">
          <mat-icon>more_horiz</mat-icon>
        </button>
        <button mat-icon-button class="close-button" (click)="closeNotificationMenu($event)" matTooltip="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <mat-menu #optionsMenu="matMenu" class="notification_action_menu">
      <button mat-menu-item (click)="markAllAsRead($event)" class="notification_action_menu_item" *ngIf="unreadCount > 0">
        <span>Mark all as read</span>
      </button>
      <button mat-menu-item (click)="markAllAsArchived($event)" class="notification_action_menu_item" *ngIf="notifications.length > 0">
        <span>Mark all archived</span>
      </button>
      <button mat-menu-item (click)="markAllReadAsArchived($event)" class="notification_action_menu_item" *ngIf="notifications.length > unreadCount">
        <span>Mark all read as archived</span>
      </button>
    </mat-menu>

    <div class="notification-list">
      <div *ngIf="isLoading" class="loading-container">
        <mat-progress-spinner mode="indeterminate" diameter="30"></mat-progress-spinner>
        <p>Loading notifications...</p>
      </div>

      <div *ngIf="!isLoading && notifications.length === 0" class="empty-state">
        <mat-icon>notifications_none</mat-icon>
        <p>No notifications</p>
      </div>

      <div *ngIf="!isLoading && notifications.length > 0" class="notifications-container">
        <div *ngFor="let notification of notifications" 
             class="notification-item" 
             [class.unread]="!notification.isRead">
          <div class="notification-content">
            <div class="notification-header-row">
              <h4 class="notification-title">{{ notification.title || 'Notification' }}</h4>
              <div class="notification-actions">
                <button mat-icon-button 
                        [class.read]="notification.isRead"
                        (click)="toggleMarkAsRead(notification, $event)"
                        [matTooltip]="notification.isRead ? 'Mark as unread' : 'Mark as read'">
                  <mat-icon>{{ notification.isRead ? 'mark_email_read' : 'mark_email_unread' }}</mat-icon>
                </button>
                <button mat-icon-button 
                        (click)="markAsArchived(notification, $event)"
                        [matTooltip]="'Archive'">
                  <mat-icon>{{ 'archive' }}</mat-icon>
                </button>
              </div>
            </div>
            <p class="notification-message">{{ notification.message || notification.body || 'No message' }}</p>
            <div class="notification-date">{{ formatDate(notification.date || notification.createdAt || notification.timestamp) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-menu>

